import {
  IGetDetails,
  IGetUpdates,
  ICreateRequest,
  IIDResult,
  IRequestCreationCompleted,
  IGetFile,
  IAddMessage,
  IAddFile,
  ICloseRequest,
  ICancelRequest,
  IGetRequestTypes,
  IGetRequestAdditionalFields,
  IGetVehicleMarks,
  ISendPaidRequestCompleteCodeOnline,
  ISendPaidRequestCompleteCodeCash,
  ISetReadedFlag,
  ICheckRequestSumIsVerified,
  IGetHouses,
  IGetHouseData,
  IAddBotCall,
  IFileInfo,
  IRequestsUpdate,
} from "@/@types/api/requests";
import { TagType } from "@/@types/components/ui/tags";
import { useStore } from "vuex";
import requestsApi from "@/api/requests";
import { downloadBlob } from "@/utils/download";

export function useRequests() {
  const $store = useStore();

  // FETCH DATA
  const fetchRequestDetails: IGetDetails = async (id) => {
    return await requestsApi.getDetails(id).then((data) => data);
  };

  const fetchRequestUpdates = async (params: IGetUpdates): Promise<IRequestsUpdate> => {
    const updateKey: string | null =
      $store.state.requests.requestList.UpdateKey;

    let _params = params;

    if (updateKey) {
      _params = {
        ..._params,
        updateKey: +updateKey,
      };
    }

    return await requestsApi.getUpdates(_params).then((data) => {
      $store.dispatch("requests/setUpdateKey", data.NewUpdateKey);

      return data;
    });
  };

  const fetchFile: IGetFile = async (id) => {
    return await requestsApi.getFile(id).then((data) => {
      // TODO: download file
      return data;
    });
  };

  // FIXME: Удалить. Использовать экшен
  const fetchRequestTypes: IGetRequestTypes = async () => {
    return await requestsApi.getRequestTypes().then((data) => data);
  };

  const fetchRequestAdditionalFields: IGetRequestAdditionalFields =
    async () => {
      return await requestsApi
        .getRequestAdditionalFields()
        .then((data) => data);
    };

  const fetchVehicleMarks: IGetVehicleMarks = async () => {
    return await requestsApi.getVehicleMarks().then((data) => data);
  };

  const fetchHouseList: IGetHouses = async (street) => {
    return await requestsApi.getHouses(street).then((data) => data);
  };

  const fetchHouse: IGetHouseData = async (id) => {
    return await requestsApi.getHouseData(id).then((data) => data);
  };

  // POST DATA

  // FIXME: Удалить. Использовать экшен
  const createRequest = async (params: ICreateRequest): Promise<IIDResult> => {
    return await requestsApi.createRequest(params).then((data) => data);
  };

  const requestCreationCompleted: IRequestCreationCompleted = async (id) => {
    return await requestsApi.requestCreationCompleted(id).then((data) => data);
  };

  const sendMessage: IAddMessage = async (params) => {
    return await requestsApi.addMessage(params).then((data) => data);
  };

  const sendFile: IAddFile = async (params) => {
    return await requestsApi.addFile(params).then((data) => data);
  };

  const closeRequest: ICloseRequest = async (params) => {
    return await requestsApi.closeRequest(params).then((data) => data);
  };

  const cancelRequests: ICancelRequest = async (requestId) => {
    return await requestsApi.cancelRequest(requestId).then((data) => data);
  };

  const sendPaidRequestCompleteCodeOnline: ISendPaidRequestCompleteCodeOnline =
    async (params) => {
      return await requestsApi
        .sendPaidRequestCompleteCodeOnline(params)
        .then((data) => data);
    };

  const sendPaidRequestCompleteCodeCash: ISendPaidRequestCompleteCodeCash =
    async (params) => {
      return await requestsApi
        .sendPaidRequestCompleteCodeCash(params)
        .then((data) => data);
    };

  const setReadedFlag: ISetReadedFlag = async (requestId) => {
    return await requestsApi.setReadedFlag(requestId).then((data) => data);
  };

  const checkRequestSumIsVerified: ICheckRequestSumIsVerified = async (
    requestId
  ) => {
    return await requestsApi
      .checkRequestSumIsVerified(requestId)
      .then((data) => data);
  };

  const addBotCall: IAddBotCall = async (params) => {
    return await requestsApi.addBotCall(params).then((data) => data);
  };

  // Helpers
  const downloadFile = (fileInfo: IFileInfo): void => {
    fetchFile(fileInfo.id).then((blob) => {
      downloadBlob(blob, fileInfo.name);
    });
  };

  const getStatusType = (statusId: number): TagType => {
    /**
     * -- Статусы (группа):
          //-- 1 - Новая заявка(не принята)
          //-- 2 - Диспетчер принял(принята)
          //-- 3 - Направлена исполнителю(не принята)
          //-- 4 - Заявка принята исполнителем(принята)
          //-- 5 – Выполнена(выполнена)
          //-- 6 - Житель подтвердил(закрыл) (закрыта)
          //-- 7 - Отменена(житель отказался) (закрыта)
          //-- 8 - Закрыта с низкой оценкой(закрыта)
          //-- 9 - Выполнение отменено(принята)
          //-- 10 - Закрыта, низкая оценка обработана(закрыта)
          //-- 11 - Закрыта сотрудником(закрыта)
          //-- 12 - Закрыта автоматически(закрыта)
    */

    if ([1, 2, 3].includes(statusId)) {
      return 'info'
    }

    if (statusId === 4) {
      return 'warning'
    }

    if ([5, 6, 8, 10, 11, 12].includes(statusId)) {
      return 'success'
    }

    if ([7, 9].includes(statusId)) {
      return 'error'
    }

    return 'neutral'
  }

  return {
    fetchRequestDetails,
    fetchRequestUpdates,
    fetchFile,
    fetchRequestTypes,
    fetchRequestAdditionalFields,
    fetchVehicleMarks,
    fetchHouseList,
    fetchHouse,

    createRequest,
    requestCreationCompleted,
    sendMessage,
    sendFile,
    closeRequest,
    cancelRequests,
    sendPaidRequestCompleteCodeOnline,
    sendPaidRequestCompleteCodeCash,
    setReadedFlag,
    checkRequestSumIsVerified,
    addBotCall,
    downloadFile,
    getStatusType,
  };
}
